import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "text" }
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_easy_login_form = _resolveComponent("easy-login-form")!

  return (!_ctx.isEstateAgencyMode)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.isDetail)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.favorite && _ctx.favorite(...args))),
              class: _normalizeClass([{ 'is-active': _ctx.ad.isFavorite }, "button button--favorite"]),
              title: _ctx.$t('AdListItemFavorite.button-favorite-title')
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('AdListItemFavorite.button-favorite')), 1)
            ], 10, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.favorite && _ctx.favorite(...args)), ["stop","prevent"])),
              class: _normalizeClass(["estate-card__favorite", { 'is-active': _ctx.ad.isFavorite }]),
              title: _ctx.$t('AdListItemFavorite.button-favorite-title')
            }, null, 10, _hoisted_3)),
        (_ctx.isLoginModalVisible)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 2,
              to: "#container"
            }, [
              _createVNode(_component_easy_login_form, {
                onClose: _ctx.closeLoginModal,
                showCloseButton: true,
                alertText: _ctx.$t('favorite-not-logged-in')
              }, null, 8, ["onClose", "alertText"])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}